import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage, injectIntl } from 'react-intl'
import { compose } from 'recompose'

import { Overview, IconLink } from 'components/misc'
import { ImageCropper } from 'containers/misc'
import { ElevatedButton } from 'components/layout'
import { Input, InputPhone, InputDate, Select } from 'components/fields'
import { apiConfiguration, apiCodeLists, apiCommon } from 'helpers/decorators/api'
import { checkEmail } from 'redux/modules/api/asyncValidations'
import { form, modal } from 'helpers/decorators'
import { validate, asyncValidate } from './edit-profile.validation'
import MODALS from 'constants/layout/modals'
import { connect } from 'react-redux'

function initialProps(data) {
  return {
    ...data,
    ...get(data, 'address'),
    countryId: get(data, 'address.country.id')
  }
}

const enhance = compose(
  connect(() => {}, {
    checkEmail,
  }),
  apiConfiguration(),
  apiCodeLists(['titles', 'phoneTypes']),
  apiCommon({
    countries: true,
  }),
  form({
    form: 'editProfile',
    disableHook: true,
    dataKey: 'profile.data',
    initialPropsMapper: initialProps,
    validate,
    asyncValidate,
  }),
  modal.trigger(),
  injectIntl
)

class EditProfileInner extends Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    onEditProfile: PropTypes.func,
    handleSubmit: PropTypes.func,
    change: PropTypes.func,
    profile: PropTypes.object,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    isAssessor: PropTypes.bool,
    intl: PropTypes.object,
    submitting: PropTypes.bool,
    values: PropTypes.any,
    codeLists: PropTypes.any,
    common: PropTypes.any,
  }

  getMainContent = () => {
    const { isAssessor, isEdit, values, intl, common } = this.props
    const acc = [
      {
        content: get(values, 'email'),
        intlKey: 'label.email',
        label: 'Email',
        ico: 'email'
      },
      {
        content: get(values, 'secondaryEmail'),
        intlKey: 'label.secondary_email',
        label: 'Secondary Email',
        ico: 'email',
        hide: isEdit || !get(values, 'secondaryEmail')
      }
    ]
    const phones = [
      {
        content: get(values, 'phone'),
        intlKey: 'label.phone',
        label: 'Phone',
        ico: 'phone',
        hide: isEdit,
      },
      {
        content: get(values, 'secondaryPhone'),
        intlKey: 'label.secondary_phone_number',
        label: 'Secondary Phone',
        ico: 'phone',
        hide: isEdit || !get(values, 'secondaryPhone')
      },
    ]

    if (!isAssessor) {
      acc.splice(acc.length, 0, ...phones)
    } else {
      acc.splice(acc.length, 0, ...[
        {
          content: get(values, 'tertiaryEmail'),
          intlKey: 'label.tertiary_email',
          label: 'Tertiary Email',
          ico: 'email',
          hide: isEdit || !get(values, 'tertiaryEmail')
        },
        [
          phones[0],
          {
            content: get(values, 'phoneType.value'),
            intlKey: 'label.phone_type',
            label: 'Phone type',
          },
        ],
        [
          phones[1],
          {
            content: get(values, 'secondaryPhoneType.value'),
            intlKey: 'label.secondary_phone_type',
            label: 'Secondary phone type',
          },
        ],
        {
          content: intl.formatDate(
            new Date(get(values, 'birthDate'))
          ),
          intlKey: 'label.birthdate',
          label: 'Date of birth',
          hide: isEdit,
        },
        {
          content: get(values, 'line1'),
          intlKey: 'label.addressLine1',
          label: 'Address Line 1',
          hide: isEdit,
        },
        {
          content: get(values, 'line2'),
          intlKey: 'label.addressLine2',
          label: 'Address Line 2',
          hide: isEdit,
        },
        [
          {
            content: get(values, 'stateOrProvinceOrRegion'),
            intlKey: 'label.state_province',
            label: 'State/Province/Region',
            hide: isEdit,
          },
          {
            content: get(values, 'city'),
            intlKey: 'label.city',
            label: 'City',
          },
        ],
        [
          {
            content: get(values, 'zipCode'),
            intlKey: 'label.post_code',
            label: 'Post code',
            hide: isEdit,
          },
          {
            content: common.countries.list.find(v => (v.value === Number(get(values, 'countryId'))))?.label,
            intlKey: 'label.country',
            label: 'Country',
          },
        ],
      ])
    }
    return acc
  }

  openPasswordModal = () => {
    // TODO: It should work without setTimeout but instead causes weird bug
    this.props.onClose()
    setTimeout(() => this.props.onOpen(MODALS.CHANGE_PASSWORD), 750)
  }
  openEmailModal = () => {
    this.props.onClose()
    setTimeout(() => this.props.onOpen(MODALS.CHANGE_EMAIL), 750)
  }

  handleSubmit = data => {
    if (this.props.isEdit) {
      return this.props.onEditProfile(
        get(this.props.profile, 'data.id'),
        data,
        {
          profile: get(this.props.profile, 'data'),
          keepModal: true,
          isAssessor: this.props.isAssessor
        }
      )
    }
  }

  render() {
    const {
      change,
      handleSubmit,
      isAssessor,
      isEdit,
      profile,
      values,
      submitting,
      codeLists,
      common,
    } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 15 }}>
          <ImageCropper
            disabled={!isEdit}
            change={change}
            photoUrl={get(values, 'photoUrl')}
          />
          {!isEdit && <Overview
            activityOverview={profile}
            loadingEnable={false}
            compact
            noIconSpace
            content={[
              {
                content: get(values, 'title'),
                intlKey: 'label.title',
                label: 'Title',
                hide: !isAssessor || !get(values, 'title'),
              },
              {
                content: get(values, 'firstName'),
                intlKey: 'label.first_name',
                label: 'First name',
                hide: !isAssessor,
              },
              {
                content: get(values, 'middleName'),
                intlKey: 'label.middle_name',
                label: 'Middle name',
                hide: !isAssessor || !get(values, 'middleName'),
              },
              {
                content: get(values, 'lastName'),
                intlKey: 'label.last_name',
                label: 'Last name',
                hide: !isAssessor,
              },
            ]}
          />}
          {isEdit && isAssessor &&
            <div className="row">
              <div className="col-xs-12">
                <Select
                  name="title"
                  label="Title"
                  intlKey="label.title"
                  options={codeLists.titles.list}
                />
              </div>
              <div className="col-xs-12">
                <Input
                  name="firstName"
                  label="First name"
                  intlKey="label.first_name"
                />
              </div>
              <div className="col-xs-12">
                <Input
                  name="middleName"
                  label="Middle name"
                  intlKey="label.middle_name"
                />
              </div>
              <div className="col-xs-12">
                <Input
                  name="lastName"
                  label="Last name"
                  intlKey="label.last_name"
                />
              </div>
            </div>}
        </div>

        <Overview
          activityOverview={profile}
          loadingEnable={false}
          content={this.getMainContent()}
        />

        {isEdit &&
          <div className="row">
            <div className="col-xs-12">
              <Input
                name="secondaryEmail"
                label="Secondary email"
                intlKey="label.secondary_email"
              />
            </div>
            {isAssessor && <div className="col-xs-12">
              <Input
                name="tertiaryEmail"
                label="Tertiary email"
                intlKey="label.tertiary_email"
              />
            </div>}
          </div>}

        {isEdit && <div className="row">
          {isAssessor ? <>
            <div className="col-xs-6">
              <InputPhone name="phone" intlKey="label.phone" label="Phone" />
            </div>
            <div className="col-xs-6">
              <Select
                label="Phone type"
                intlKey="label.phone_type"
                name="phoneType.value"
                options={codeLists.phoneTypes.list}
              />
            </div>
            <div className="col-xs-6">
              <InputPhone
                name="secondaryPhone"
                intlKey="label.secondary_phone_number"
                label="Secondary Phone"
              />
            </div>
            <div className="col-xs-6">
              <Select
                label="Secondary phone type"
                intlKey="label.secondary_phone_type"
                name="secondaryPhoneType.value"
                options={codeLists.phoneTypes.list}
              />
            </div>
          </> : <>
            <div className="col-xs-12">
              <InputPhone name="phone" intlKey="label.phone" label="Phone" />
            </div>
            <div className="col-xs-12">
              <InputPhone
                name="secondaryPhone"
                intlKey="label.secondary_phone_number"
                label="Secondary Phone"
              />
            </div>
          </>}
        </div>}

        {isEdit && isAssessor && <div className="row">
          <div className="col-xs-6">
            <InputDate
              label="Date of birth"
              intlKey="label.birthdate"
              name="birthDate"
              allowFuture={false}
            />
          </div>
        </div>}

        {isEdit && isAssessor && <div className="row">
          <div className="col-xs-12">
            <Input
              label="Address Line 1"
              intlKey="label.addressLine1"
              name="line1"
            />
          </div>
          <div className="col-xs-12">
            <Input
              label="Address Line 2"
              intlKey="label.addressLine2"
              name="line2"
            />
          </div>
          <div className="col-xs-6">
            <Input
              label="State/Province/Region"
              intlKey="label.state_province"
              name="stateOrProvinceOrRegion"
            />
          </div>
          <div className="col-xs-6">
            <Input
              label="City"
              intlKey="label.city"
              name="city"
            />
          </div>
          <div className="col-xs-6">
            <Input
              label="Post code"
              intlKey="label.post_code"
              name="zipCode"
            />
          </div>
          <div className="col-xs-6">
            <Select
              label="Country"
              intlKey="label.country"
              name="countryId"
              options={common.countries.list}
              searchable
            />
          </div>
        </div>}

        {isEdit &&
          <ElevatedButton isLoading={submitting} uppercase rounded submit>
            <FormattedMessage id="button.save" defaultMessage="Save" />
          </ElevatedButton>}

        {!isEdit &&
          <div>
            <IconLink icon="icon-key" onClick={this.openPasswordModal}>
              <FormattedMessage
                id="button.change_password"
                defaultMessage="Change Password"
              />
            </IconLink>
            <IconLink icon="email" onClick={this.openEmailModal}>
              <FormattedMessage
                id="button.change_email"
                defaultMessage="Change email"
              />
            </IconLink>
          </div>}
      </form>
    )
  }
}

export default enhance(EditProfileInner)
